// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LgxQ","option":"styles_option__2seKM","active":"styles_active__NNoNM"};